var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('h6',[_c('span',[_vm._v("Company Name")]),_vm._v(" 2021 © All right reserved.")])])}]

export { render, staticRenderFns }